import { GraphQLClient } from "graphql-request";
import { MYBESTUSER_API } from "../config/environment";
import store from "../store/configureStore";
import { setNotify } from "../actions/notifyActions";

let graphQLClient = null;

const create = () => {
  const token = localStorage.getItem("token");

  const client = new GraphQLClient(MYBESTUSER_API + "/graphql", {
    headers: {
      authorization: token ? `Bearer ${token}` : null
    }
  });

  // Wrap request method to catch auth errors
  const originalRequest = client.request.bind(client);
  client.request = async (...args) => {
    try {
      return await originalRequest(...args);
    } catch (error) {
      // Check if error is authentication related
      const isAuthError =
        error.response?.status === 401 ||
        error.message?.includes("Unauthorized") ||
        error.message?.includes("User must login") ||
        error.message?.includes("Token invalidated") ||
        error.message?.includes("Token is revoked");

      if (isAuthError) {
        console.warn('[GraphQL Client] Auth error - Token invalid or user logged out');

        // Clear token from localStorage
        localStorage.removeItem("token");

        // Dispatch notify action to show modal
        store.dispatch(
          setNotify(
            "Your session has expired or you have been logged out. Please login again.",
            null, // confirm callback
            null, // cancel callback
            true  // forceRelogin = true
          )
        );
      }

      throw error;
    }
  };

  return client;
};

export const initGQLClient = () => {
  if (!graphQLClient) {
    graphQLClient = create();
  }

  return graphQLClient;
};
